"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (data, headers) {
    var contentType = headers['Content-Type'] || headers['content-type'];
    if (contentType) {
        if (/^application\/json/.test(contentType))
            return JSON.parse(data);
        if (/^application\/x-www-form-urlencoded/.test(contentType))
            return new URLSearchParams(data);
    }
    return data;
});
//# sourceMappingURL=untransformData.js.map